import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./securityDetails.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { PopoverHorizontalOrientation, PopoverVerticalOrientation } from 'wds/popover';
import { WireI18n } from '~/modules/stores/i18nStore';
import { selectIsAppListing, selectIsLinkListing, selectIsSalesforceProduct } from '~/modules/stores/listingStore';
import { DeviceType, selectDeviceType, viewportStore } from '~/modules/stores/viewportStore';
import { printDateSimple } from '~/modules/utilities/time';
class SecurityDetails extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listing = void 0;
    this.staticLabels = void 0;
    this.deviceType = void 0;
  }
  get isDesktop() {
    return this.deviceType === DeviceType.DESKTOP;
  }
  get popoverOrientation() {
    const popoverOrientation = {
      vertical: PopoverVerticalOrientation.BOTTOM,
      horizontal: PopoverHorizontalOrientation.RIGHT
    };
    if (this.isDesktop) {
      popoverOrientation.horizontal = PopoverHorizontalOrientation.LEFT;
    }
    return popoverOrientation;
  }
  get isLinkListing() {
    return selectIsLinkListing(this.listing);
  }
  get isSalesforceProductListing() {
    return selectIsSalesforceProduct(this.listing);
  }
  get requirements() {
    const isLinkListing = this.isLinkListing;
    if (!isLinkListing || !this.isSalesforceProductListing) {
      return this.staticLabels.apiOrAppListing.requirements;
    } else if (isLinkListing) {
      return this.staticLabels.linkListing.requirements;
    }
    return this.staticLabels.salesforceProductListing.requirements;
  }
  get description() {
    if (this.isSalesforceProductListing) {
      return '';
    } else if (this.isLinkListing) {
      return this.staticLabels.linkListing.description;
    }
    return this.staticLabels.apiOrAppListing.description;
  }
  get lastReviewedDate() {
    if (this.isLinkListing) {
      return '';
    }
    const approvalDateAsString = this.listing?.solution?.securityReview?.approvalDate;
    return printDateSimple(approvalDateAsString);
  }
  get lastReviewedVersion() {
    if (selectIsAppListing(this.listing) && !this.isSalesforceProductListing) {
      return this.listing.solution?.securityReview?.lastApprovedVersion ?? '';
    }
    return '';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SecurityDetails, {
  publicProps: {
    listing: {
      config: 0
    }
  },
  wire: {
    staticLabels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18nStaticCache => i18nStaticCache.securityDetails
        };
      }
    },
    deviceType: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: viewportStore,
          selector: selectDeviceType
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(SecurityDetails, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;